<template>
    <div>
        <InputDropdown ref="elemDdlBrand" :inputLbl="lbl.search.carBrand" :errorInfo="errInfo[0]"
            v-model:inputValue="inputValue" :itemList="expertList" />
    </div>
</template>

<script>
import { FormHelper } from '@/helper/FormHelper';
import { computed, defineComponent, inject, ref } from 'vue';
import { useSearchService } from '../service/useSearchService';

// ocmponent
import InputDropdown from '@/components/Input/label/InputDropdown.vue';

export default defineComponent({
    props: {
        modelValue: {
            type: [String, Number]
        }
    },
    components: {
        InputDropdown
    },
    emits: ["update:modelValue"],
    setup: function (props, context) {
        const { lbl } = inject("LocaleStore")
        const errInfo = ref(FormHelper.genErrorInfo(1))
        const expertList = ref([])
        const searchService = useSearchService()

        const inputValue = computed({
            get: function () {
                return props.modelValue
            },
            set: function (val) {
                context.emit("update:modelValue", val)
            }
        })

        searchService.getExpert().then((items) => {
            expertList.value = items
        })

        return {
            lbl,
            errInfo,
            inputValue,
            expertList
        }
    }
})
</script>

